import React from 'react';
import Button from '../../atoms/button/Button';
import { Link } from 'react-router-dom';

const ErrorBoundary = () => {
  return (
    <div className='background flex h-screen items-center justify-center'>
      <div className='sidemenu rounded-lg p-10 shadow-lg'>
        <h1 className='mb-4 text-4xl font-bold'>Oops, something went wrong!</h1>
        <p className='text-color'>We apologize for the inconvenience.</p>
        <Link to='/'>
          <Button
            title='Go back'
            color='btn-primary'
            className='mt-4'
          />
        </Link>
      </div>
    </div>
  );
};

export default ErrorBoundary;
